<template>
  <div class="product">

    <h1>Report Prodotto</h1>

      <div class="report">

        <div class="row">
            <div class="col-3">nome</div>
            <div class="col-9">{{name}}</div>
        </div>
        <div class="row">
            <div class="col-3">ean</div>
            <div class="col-9">{{ean}}</div>
        </div>
        <div class="row">
            <div class="col-3">sku</div>
            <div class="col-9">{{sku}}</div>
        </div>
        <div class="row">
            <div class="col-3">price</div>
            <div class="col-9">{{formatPrice(price)}}</div>
        </div>

      </div>

      <h3>Filtri</h3>

      <div class="filters">

        <div class="row">
            <div class="col-3">sito</div>
            <div class="col-9">
                <select class="form-control" @change="handleChange($event)">
                  <option>seleziona</option>
                  <option v-for="website in websites" v-bind:key="website" :value="website._id">{{ website.name }}</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="col-3">data da</div>
            <div class="col-9">
                <date-picker v-model="date1" :first-day-of-week="1" :lang="lang"></date-picker>
            </div>
        </div>

        <div class="row">
            <div class="col-3">data a</div>
            <div class="col-9">
                <date-picker v-model="date2" :first-day-of-week="1" :lang="lang"></date-picker>
            </div>
        </div>

        <div class="text-center">
            <button class="app_btn" @click="loadReport">Carica</button>
        </div>

      </div>

      <h3>Report</h3>

      <div class="table-data" v-if="report">
          <div v-for="item in report" v-bind:key="item">
              <div class="row">
                  <div class="col-6 text-center">{{formatDate(item.date)}}</div>
                  <div class="col-6 text-center">{{formatPrice(item.price)}}</div>
              </div>
          </div>
      </div>

      <div>
        <button class="app_btn" @click="$router.go(-1)">Indietro</button>
      </div>

  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import ProductsService from '@/services/ProductsService'
import WebsitesService from '@/services/WebsitesService'
export default {
  name: 'ReportProductDate',
  components: { DatePicker },
  data () {
    return {
        lang: 'it',
        website_id: '',
        date1: new Date(),
        date2: new Date(),
        name: '',
        ean: '',
        sku: '',
        price: 0,
        websites: [],
        report: []
    }
  },
  mounted () {
      this.fillData()
      this.getProduct()
      this.getWebsites()
  },
  methods: {
    fillData () {
        var date = new Date()
        this.date1 = new Date().setDate(date.getDate() - 10)
        /* var labels = []
        var datasets = []
        for (var item of this.dataseries[0].data) {
            labels.push(this.formatDate(item.date))
        }
        for (var index in this.dataseries) {
            var dataset = {
                label: this.dataseries[index].name,
                backgroundColor: this.getColor(index),
                borderColor: this.getColor(index),
                fill: false
            }
            var dataArray = []
            for (var itemt of this.dataseries[index].data) {
                dataArray.push(itemt.price.toFixed(2))
            }
            dataset.data = dataArray
            datasets.push(dataset)
        }
        this.datacollection = {
          labels: labels,
          datasets: datasets
      } */
    },
    getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
    async getProduct () {
      const response = await ProductsService.reportsku({
        sku: this.$route.params.sku
      })
      // console.log(response.data)
      this.name = response.data.name
      this.ean = response.data.ean
      this.sku = response.data.sku
      this.price = response.data.price
      // this.websites = response.data.websites
    },
    async getWebsites () {
      const response = await WebsitesService.fetch()
      this.websites = response.data.websites
    },
    handleChange (event) {
        this.website_id = event.target.value
    },
    async loadReport () {
         // console.log(Math.floor(new Date(this.date1) / 1000))
         const response = await ProductsService.reportdate({
             sku: this.sku,
             website_id: this.website_id,
             date1: Math.floor(new Date(this.date1) * 1),
             date2: Math.floor(new Date(this.date2) * 1)
         })
         this.report = response.data
         // console.log(this.report)
    },
    formatPrice (value) {
        // console.log(value)
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate (value) {
        // console.log(value)
        var date = new Date(value)
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    }
  }
}
</script>
<style type="text/css">
.report {
  margin-bottom: 20px;
}
.report div, .filters div {
  text-align: left;
}
.table-data {
  margin-bottom: 20px;
}
.table-data div {
  text-align: left;
}
.filters .row {
    margin-bottom: 10px;
}
.mx-datepicker {
  width: 100%!important;
}
.app_btn {
  margin: 20px 0;
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  max-width: 500px;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportProductDate.vue